<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
        <button v-bind:class="{'font-weight-bold': showCoach}" class="status-button" @click="showCoach = true">{{ $t('coaches') }}</button><span> | </span><button v-bind:class="{'font-weight-bold': !showCoach}" class="status-button" @click="showCoach = false">{{ $t('students') }}</button>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addUser">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <!-- API errors of the list's actions (delete, status...) -->
    <FormApiErrors v-if="!showChangePwdPopup" show-text></FormApiErrors>
    <CTableWrapper ref="table" hover striped :caption="$t('users')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- generate link popup -->
    <BasePopUp v-if="showChangePwdPopup" @popUpClosed="showChangePwdPopup = false">
      <template v-slot:body>
        <div class="d-flex flex-column p-3" style="gap: 1rem">
          <span class="nav-item-title" v-html="$t('changePasswordMessage', {name: escapeHtml(`${currentUser.firstName} ${currentUser.lastName}`)})"/>
          <CRow>
            <CCol sm="12">
              <CInput 
                class="mb-2" 
                :label="$t('password')" 
                :type="showPassword ? 'text' : 'password'"
                v-model="password" 
                :is-valid="passwordValidator() && errorValidator('Password')"
                :invalid-feedback="errorOutput['Password']"
              />
              <input type="checkbox" id="showPassword" v-model="showPassword" />
              <label class="mx-2" for="showPassword" @chnage="showPassword = !showPassword">Show password</label>
            </CCol>
          </CRow>
          <!-- API errors that belong to no field above -->
          <FormApiErrors :fields="['Password']"></FormApiErrors>
          <!-- Action button -->
          <CCol class="d-flex justify-content-end mt-3">
            <CRow sm="2">
              <div class="d-flex" style="gap: 1rem">
                <CSpinner v-if="loading" variant="success" small></CSpinner>
                <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                <CButton type="button" class="btn btn-primary" @click.prevent="showChangePwdPopup = false; triedSubmit = false; password = null">{{ $t('close') }}</CButton>
              </div>
            </CRow>
          </CCol>
        </div>
      </template>
    </BasePopUp>
  </div>
</template>
 
<script>
import FormApiErrors from '@/controls/FormApiErrors.vue';
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
// import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase, escapeHtml } from "@/helpers/utils.js";
import BasePopUp from "@/controls/shareLink/BasePopUp.vue";

export default {
  components: { FormApiErrors, CTableWrapper, SearchBar, BasePopUp },
  data () {
    return {
      currentPage: 1,
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'resendEmail', label: i18n.t('resendEmail') },
        { key: 'changePassword', label: i18n.t('changePassword')},
        { key: 'delete', label: i18n.t('delete') },
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      showCoach: true,
      showChangePwdPopup: false,
      password: null,
      triedSubmit: false,
      currentUser: null,
      showPassword: false,
    }
  },
  computed: {
    ...mapState('users', ['getUsersOutput']),
    ...mapState('users', ['requestConfirmTokenOutput']),
    ...mapState('users', ['deleteUserOutput']),
    ...mapState('users', ['processTask']),
    ...mapState({
      alertType: state => state.alert.type,
      alertOutput: state => state.alert.output
    }),

    usersInfo: function() {
      return this.getUsersOutput ? this.getUsersOutput : null;
    },
    fields: function()
    {
      var result =      
      [
        { key: 'firstName', label: i18n.t('firstName'), sortable: true },
        { key: 'lastName', label: i18n.t('lastName'), sortable: true },
        { key: 'email', label: i18n.t('email'), sortable: true },
        { key: 'phoneNumber', label: i18n.t('phoneNumber'), sortable: true }
      ];

      if(this.showCoach)
      {
        result.push({ key: 'maxStudents', label: i18n.t('maxStudents'), sortable: true });
      }

      return result;
    },
    items: function()
    {
      var result = [];

      if(this.usersInfo && this.usersInfo.data)
      {
        result = this.usersInfo && this.usersInfo.data;
        result.forEach(user => {
          if(!user.emailConfirmed)
          {
            user['_classes'] = "signup-pending";
          }
          else
          {
            user['_classes'] = "signup-confirmed";
          }
        });
      }

      return result;
    },
    pages: function()
    {
      return this.usersInfo ? this.usersInfo.totalPages : 1;
    },
    errorOutput: function () {
      let result = [];

      if (this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput)) {
        result = this.alertOutput.reduce(function (accum, currentVal) {
          accum[currentVal.key] = currentVal.value;
          return accum;
        }, {});
      }

      if (this.triedSubmit && this.password) {
        let passwordPattern = /(?=.*[A-Za-z])(?=.*\d).{6,}$/g;

        if (!this.password.match(passwordPattern)) {
          result['Password'] = this.$i18n.t("forbiddenPassword");
        }
      }

      return result;
    },
    isPasswordValid: function () {
      return this.passwordValidator() != false;
    },
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    escapeHtml,
    ...mapActions('users', ['getUsers']),
    ...mapActions('users', ['requestConfirmToken']),
    ...mapActions('users', ['deleteUser']),
    ...mapActions('users', ['updateUserPassword']),

    addUser()
    {
      this.$router.push({name: "UserAdd"});
    },
    rowClicked (item, index) {
      this.$router.push({name: "UserEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "UserEdit", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'resendEmail':
        {
          if(confirm(this.$i18n.t('confirmResendEmail'))){
            this.requestConfirmToken(item.email);
          }
          break;
        }
        case 'changePassword':
        {
          this.showChangePwdPopup = true;
          this.currentUser = item
          break;
        }
        case 'delete':
        {
          if(confirm(this.$i18n.t('confirmDelete'))){
            this.deleteUser(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      this.currentPage = currentPage;

      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      input.coach = this.showCoach;
      
      this.getUsers(input); 
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    },
    submitClicked() {
      this.triedSubmit = true;
      if (this.isPasswordValid) {
        this.loading = true;
        const payload = {
          id: this.currentUser.id,
          newPassword: this.password,
        };
        this.updateUserPassword(payload);
      }
    },
    passwordValidator() {
      let result = undefined;

      if (this.triedSubmit) {
        if (this.password) {
          result = true;
          } else {
            result = false;
        }
      }
      return result;
    },
    errorValidator(fieldName) {
      var result = undefined;

      if (this.alertOutput && Array.isArray(this.alertOutput)) // Error alertOutput
      {
        if (this.alertOutput.find(obj => {
          return obj.key === fieldName
        })) {
          result = false;
        }
      }
      return result;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    getUsersOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    requestConfirmTokenOutput: function(val)
    {
      this.loading = val === null;
      if(val !== null)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    deleteUserOutput: function(val)
    {
      this.loading = val === null;
      if(val !== null)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    showCoach: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    processTask: function (val) {
      if(val !== null) {
        if(val == false) {
          this.loading = false;
        }
        else {
          this.password = '';
          this.showPassword = false;
          this.showChangePwdPopup = false;
          this.currentUser = null;
          this.triedSubmit = false;
          this.loading = false;
          this.updateItemsRequested(this.currentPage, this.itemsPerPage);
        }
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}

.signup-pending
{
  background-color: indianred !important;
  color: white;
}

.signup-confirmed button:nth-child(2)
{
  display: none;
}
.popup {
  max-width: 500px;
}
@media (max-width: 575.98px){
  .popup {
    max-width: 100%;
  }
}
</style> 